import { getTokenSizeDisplayDecimals } from '@ui/utils/getTokenSizeDisplayDecimals';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';

import { SupportedSymbol } from './price/priceLatest/store';
import { usePriceLatest } from './price/usePriceLatest';

export const useTokenSizeDisplayDecimals = (symbol?: SupportedSymbol) => {
  const tokenPrice = usePriceLatest(symbol);

  return useMemo(() => {
    if (isNil(tokenPrice) || isNaN(tokenPrice.toNumber())) return 2; // default 2

    return getTokenSizeDisplayDecimals(tokenPrice.toNumber());
  }, [tokenPrice]);
};


